import React from 'react'
import { Row, Col, Button } from 'antd'
import { ReactSVG } from 'react-svg'

function CheckInDone(props) {
    const {history, step, setStep, setActiveRecord} = props

    return (
        <div className="bid-done-board">
            <Row>
                <Col span={24} className="t-center">
                    <ReactSVG src="/images/done.svg" />
                    <h3 className="mt-3">Congratulations! Your flight is approved</h3>
                    <p className="fly-notes mt-2 t-center">You are ready for your flight! Please arrive at least 30 minute before your departure time.</p>
                </Col>
            </Row>
            <Row className="mt-5">
                <Col span={24}>
                    <Button type="primary" className="fly-btn w-full" onClick={() => {
                            setActiveRecord()
                            history.push('/client/flight-requests?ft=upcoming')
                        }}>
                        Go to My Flights
                    </Button>
                </Col>
            </Row>
        </div>
    )
}

export default CheckInDone
